import { type FieldError } from "react-hook-form";

/**
 * Zod array item errors (e.g. `z.array(z.string().min(3))`) map to `errors.keywords[0].message`,
 * not `errors.keywords.message`. Read root message first, then first nested item message.
 */
export default function getFirstNestedFieldMessage(record: Record<string, unknown>): string | undefined {
  for (const value of Object.values(record)) {
    if (value && typeof value === "object" && "message" in value && typeof (value as FieldError).message === "string") {
      return (value as FieldError).message;
    }
  }
  return undefined;
}
